import React, { useMemo } from 'react';
import { BinStatusContext, BinStatusContextProps, binStatusSlice } from '../context/BinStatusContext';
import { BinStatus, SystemBinStatus } from '../types/bin/binStatus';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface BinStatusroviderProps {
  children: React.ReactNode;
}

export default function BinStatusrovider({ children }: BinStatusroviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.binStatuses.items);
  const loading = useAppSelector(state => state.binStatuses.loading);

  const binStatus = useMemo(() => {
    const map = new Map(items.map(item => [item.id, new BinStatus(item)]));
    map.delete(SystemBinStatus.id);
    return map;
  }, [items]);

  const binContext: BinStatusContextProps = {
    binStatuses: binStatus,
    binStatusesLoading: loading,
    setBinStatuses: (binStatuses: Map<string, BinStatus>) =>
      dispatch(binStatusSlice.actions.set([...binStatuses.values()])),
  };

  return <BinStatusContext.Provider value={binContext}>{children}</BinStatusContext.Provider>;
}
